export const escapeCoveoQueryValue = (value: string) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

const normalizeTopicNameKey = (value: string) => value.trim().toLowerCase().replace(/\s+/g, ' ');

const COVEO_TOPIC_NAME_MAP: Record<string, string> = {
  [normalizeTopicNameKey('Career and Leadership')]: 'Career & Leadership',
  [normalizeTopicNameKey('Career & Leadership')]: 'Career & Leadership',
  [normalizeTopicNameKey('Economy and Finance')]: 'Economy & Finance',
  [normalizeTopicNameKey('Economy & Finance')]: 'Economy & Finance',
  [normalizeTopicNameKey('ESG Risk and Compliance')]: 'ESG, Risk & Compliance',
  [normalizeTopicNameKey('ESG, Risk & Compliance')]: 'ESG, Risk & Compliance',
  [normalizeTopicNameKey('Ethics')]: 'Ethics',
  [normalizeTopicNameKey('Financial accounting')]: 'Financial Accounting',
  [normalizeTopicNameKey('Financial Accounting')]: 'Financial Accounting',
  [normalizeTopicNameKey('Management accounting')]: 'Management Accounting',
  [normalizeTopicNameKey('Management Accounting')]: 'Management Accounting',
  [normalizeTopicNameKey('Taxation and Superannuation')]: 'Taxation & Superannuation',
  [normalizeTopicNameKey('Taxation & Superannuation')]: 'Taxation & Superannuation',
  [normalizeTopicNameKey('Technology and Data')]: 'Technology and Data',
  [normalizeTopicNameKey('Technology & Data')]: 'Technology and Data',
  [normalizeTopicNameKey('Business Management')]: 'Business Management',
};

export const getCoveoTopicName = (topicName: string) => (
  COVEO_TOPIC_NAME_MAP[normalizeTopicNameKey(topicName)] || topicName
);

export const getCoveoLocationFilter = (countryName: string) => {
  if (countryName.trim().toLowerCase() === 'hong kong') {
    return '(@commonlocation=="Hong Kong (SAR China)" OR @commonlocation=="Hong Kong SAR")';
  }

  return `@commonlocation=="${escapeCoveoQueryValue(countryName)}"`;
};

export const toIsoDateString = (value: unknown): string => {
  if (value == null || value === '') {
    return '';
  }

  const timestamp = typeof value === 'number' ? value : Number(value);
  const date = Number.isNaN(timestamp) ? new Date(String(value)) : new Date(timestamp);

  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
};
